export default {
  props: ['fullscreen'],
  data() {
    return {
      showPrev: false,
      showNext: false,
      loading: true,
    };
  },
  computed: {
    product() {
      return this.myOrder.product;
    },
    productItem() {
      return this.myOrder.productItem;
    },
    selectedPhotos() {
      return this.myOrder ? this.myOrder.photos : [];
    },
    loadingPhotosByParams() {
      return this.$store.getters.LOADING_PHOTOS_BY_PARAMS;
    },
    orderedPhotos() {
      return this.$store.getters.ORDERED_PHOTOS;
    },
    carouselView() {
      return this.$store.getters.CAROUSEL_VIEW;
    },
    photoItem() {
      return this._.find(this.albumPhotos, {id: this.carouselView});
    },
    hasActionBar() {
      return !!document.getElementById('tags') || !!document.getElementById('sorting');
    },
  },
  watch: {
    carouselView(photoId, oldIPhotoId) {
      if (photoId && !oldIPhotoId) {
        this.loading = true;

        this.prev(photoId, false);
        this.next(photoId, false);
      }
    },
  },
  methods: {
    isChecked(id) {
      return typeof this._.find(this.selectedPhotos, {id}) !== 'undefined';
    },
    toggle(item) {
      if (this.isChecked(item.id) && this.selectedPhotos.length > 1) {
        this.$store.dispatch('REMOVE_PHOTO', item.id);
      } else if (!this.isChecked(item.id) && !this.productItem.limitTo) {
        this.$store.dispatch('ADD_PHOTO', item);
      } else if (!this.isChecked(item.id) && this.selectedPhotos.length < this.productItem.limitTo) {
        this.$store.dispatch('ADD_PHOTO', item);
      }

      const selectedPhotosLength = this.selectedPhotos.length;

      const limitFrom = this.productItem.limitFrom;
      const limitTo = this.productItem.limitTo;

      if (this.selectedPhotos.length === limitTo) {
        this.toast(null, this.$t('messages.default_limits', {selectedPhotosLength, limitFrom, limitTo}), 'info');
      }
    },
    prev(currentId, execute = true) {
      const currentIndex = this._.findIndex(this.albumPhotos, {id: currentId});
      const prevIndex = currentIndex === 0
          ? this.albumPhotos.length - 1
          : currentIndex - 1;
      const prevIndex2 = prevIndex === 0 ? this.albumPhotos.length - 1 : prevIndex -
          1;

      const photo = this.albumPhotos[execute ? prevIndex2 : prevIndex];
      const src = photo ? photo.large_photo : '';

      if (this.isCached(src)) {
        this.showPrev = true;
      } else {
        this.showPrev = false;
        this.loadPhoto(src, 'prev');
      }

      if (execute) {
        this.$store.dispatch('SET_CAROUSEL_VIEW', this.albumPhotos[prevIndex].id);
      }
    },
    next(currentId, execute = true) {
      const currentIndex = this._.findIndex(this.albumPhotos, {id: currentId});
      const nextIndex = currentIndex === this.albumPhotos.length - 1
          ? 0
          : currentIndex + 1;
      const nextIndex2 = nextIndex === this.albumPhotos.length - 1 ? 0 : nextIndex +
          1;

      const photo = this.albumPhotos[execute ? nextIndex2 : nextIndex];
      const src = photo ? photo.large_photo : '';

      if (this.isCached(src)) {
        this.showNext = true;
      } else {
        this.showNext = false;
        this.loadPhoto(src, 'next');
      }

      if (execute) {
        this.$store.dispatch('SET_CAROUSEL_VIEW', this.albumPhotos[nextIndex].id);
      }
    },
    loadPhoto(src, action = 'prev') {
      const img = new Image(0, 0);

      img.src = src;
      img.onload = () => action === 'next'
          ? this.showNext = true
          : this.showPrev = true;
    },
    isCached(src) {
      const image = new Image();
      image.src = src;

      return image.complete;
    },
  },
  created() {
    this.$store.dispatch('SET_CAROUSEL_VIEW', null);

    if (this.productItem.limitTo > 0) {
      this.$store.dispatch('SET_PHOTOS', this.selectedPhotos.slice(0, this.productItem.limitTo));
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!localStorage.getItem(`select-more-photos`)) {
        this.showSelectMorePhotosModal();
      }
    });

    document.onkeydown = evt => {
      evt = evt || window.event;

      if (this.photos) {
        if ((evt.keyCode === 37 || evt.keyCode === 8)
            && this.photos.length > 1
            && document.getElementById('carouselBtnPrev')
            && !document.getElementById('carouselBtnPrev').
                classList.
                contains('prev--disabled')) {
          document.getElementById('carouselBtnPrev').click();
        } else if (evt.keyCode === 39
            && this.photos.length > 1
            && document.getElementById('carouselBtnNext')
            && !document.getElementById('carouselBtnNext').
                classList.
                contains('next--disabled')) {
          document.getElementById('carouselBtnNext').click();
        }
      }
    };
  },
};
